export class SchedulingController {
    constructor($scope, scheduledTasks, tasksQueue, LoaderService) {
        LoaderService.off();
        console.log(scheduledTasks);
        $scope.scheduledTasks = scheduledTasks.sort((tsk1, tsk2) => tsk1.id - tsk2.id);
        $scope.tasksQueue = tasksQueue;
        this.$scope = $scope;
    }
}
